import React, { useState, useEffect } from "react";
import { Redirect } from 'react-router-dom'
import { useIntl, FormattedMessage } from 'react-intl'
import * as Utils from '../../commons/utils/Utils.js'
import {
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
	TablePagination,
	CircularProgress,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import UpIcon from '@material-ui/icons/KeyboardArrowUp'
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles.js'
import Security from '../../commons/security/Security.js'
import PoliticasPrivacidadGridRow from './PoliticasPrivacidadGridRow.jsx'
import PoliticasPrivacidadGridFiltros from './PoliticasPrivacidadGridFiltros.jsx'
import Sort from "../../assets/images/llantas/table/sort.svg";
import SortAsc from "../../assets/images/llantas/table/sort-asc.svg";
import SortDesc from "../../assets/images/llantas/table/sort-desc.svg";

const PAGINATION_INIT = {
	page: 0,
	count: 0,
	perPage: 10,
}

const FILTER_QUERY_INIT = {
	titulo: "",
	version: "",
	showInactivos: '',
}

const SORT_QUERY_INIT = {
	titulo: "",
	id: ""
}

const PoliticasPrivacidadGrid = (props) => {
	const intl = useIntl()

	const [loading, setLoading] = useState(false)
	const [redirectTo, setRedirectTo] = useState(null)

	const [searchActive, setSearchActive] = useState(false)
	const [pagination, setPagination] = useState({ ...PAGINATION_INIT })
	const [paginationCount, setPaginationCount] = useState(0)

	const [filterResetInputs, setFilterResetInputs] = useState(false)
	const [filterQuery, setFilterQuery] = useState(null)

	const [sortQuery, setSortQuery] = useState({ ...SORT_QUERY_INIT })
	const [dropdownActive, setDropdownActive] = useState(false)

	const [politicas, setPoliticas] = useState([])
	const [canCrear, setCanCrear] = useState(false)
	const [canVisualizar, setCanVisualizar] = useState(false)

	useEffect(() => {
		setLoading(true)
		if (Security.hasPermission("POLITICAS_PRIVACIDAD_LISTAR")) {
			setCanCrear(Security.hasPermission('POLITICAS_PRIVACIDAD_CREAR'))
			setCanVisualizar(Security.hasPermission('POLITICAS_PRIVACIDAD_VISUALIZAR'))
			filterQuery && fetchPoliticas()
		} else {
			setRedirectTo("/error")
		}
		return () => { }
	}, [pagination, filterQuery, sortQuery])

	const fetchPoliticas = () => {
		Promise.all([
			Utils.getData('/politicas-privacidad' + getQuery()),
		])
		.then((data) => {
			setPoliticas(data[0].politicas)
			setLoading(false)
			setPaginationCount(data[0].pagination.count)
		})
		.catch(() => {
			setLoading(false)
		})
	}

	const getQuery = () => {
		let q = "?page=" + pagination.page + "&perPage=" + pagination.perPage
		q += '&titulo=' + filterQuery.titulo
		q += '&version=' + filterQuery.version
		q += "&showInactivos=" + filterQuery.showInactivos
		q += '&tituloSort=' + sortQuery.titulo
		q += '&idSort=' + sortQuery.id
		return q
	}

	const handleChangePage = (event, newPage) => {
		setPagination({ ...pagination, page: newPage })
	}

	const handleChangeRowsPerPage = (event) => {
		setPagination({ ...pagination, perPage: parseInt(event.target.value, 10), page: 0 })
	}

	const requestSort = (key) => {
		let query = { ...sortQuery }
		let aux = sortQuery[key]
		query["titulo"] = ""
		pagination.page = 0
		if (!aux) query[key] = "asc"
		else if (aux === "desc") query[key] = "asc"
		else query[key] = "desc"
		setSortQuery(query)
	}

	const handleFilterReset = () => {
		setPagination(PAGINATION_INIT)
		setFilterQuery(FILTER_QUERY_INIT)
		setDropdownActive(false)
		setSortQuery(SORT_QUERY_INIT)
		setSearchActive(false)
		setFilterResetInputs(true)
	}

	const handleFilterChange = () => {
		setPagination(prevState => ({ ...prevState, page: 0 }))
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			<div className="card">
				<div className="card-content collpase show">
					<div className="card-body card-dashboard">
						<div className="container-fluid mb-1">
							<div className="row dt-icons">
								<div className="col">
									{canCrear &&
										<div
											className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
											style={{ height: 55 }}
											title={intl.formatMessage({ id: 'Nuevo', defaultMessage: 'Nuevo' })}
											onClick={() => setRedirectTo(props.match.url + '/add')}
										>
											<i className="ft-plus"></i>
										</div>
									}
									<div
										className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
										onClick={() => setDropdownActive(!dropdownActive)}
									>
										{dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
									</div>
								</div>
								<div className="col">
									{searchActive && (
										<div className="btn-dt-main round-icon">
											<div
												className="text-center"
												style={{
													height: '25px',
													borderRadius: '3px',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													paddingLeft: '8px',
													backgroundColor: '#5AAC43',
													color: 'white',
												}}
											>
												<div className="text-center" style={{ width: '100%', fontSize: '12px', fontWeight: '500' }}>
													{politicas.length} de {paginationCount} resultados de busqueda
												</div>
												<div className="resultados-busqueda-notif">
													<i className="las la-times la-xs cursor-pointer" onClick={() => handleFilterReset()}></i>
												</div>
											</div>
										</div>
									)}
								</div>
								<div className="col"></div>
							</div>
						</div>

						<PoliticasPrivacidadGridFiltros
							dropdownActive={dropdownActive}
							setDropdownActive={setDropdownActive}
							filterResetInputs={filterResetInputs}
							setFilterResetInputs={setFilterResetInputs}
							filterQuery={filterQuery}
							setFilterQuery={setFilterQuery}
							searchActive={searchActive}
							setSearchActive={setSearchActive}
							pagination={pagination}
							handleFilterChange={handleFilterChange}
						/>

						<TableContainer>
							<Table aria-label="politicas table" className="table-hover">
								<TableHead>
									<TableRow>
										<StyledTableCell align="left" onClick={() => requestSort("id")} style={{ width: "50px", cursor: "pointer" }}>
											<FormattedMessage id="Id" defaultMessage="Id" />
											<img className="ml-1" src={sortQuery.id === "" ? Sort : sortQuery.id === "asc" ? SortAsc : SortDesc} alt="/" style={{ height: "12px", width: "22px" }} />
										</StyledTableCell>
										<StyledTableCell></StyledTableCell>
										<StyledTableCell align="left" onClick={() => requestSort("titulo")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="politicasPrivacidad.titulo_campo" defaultMessage="Título" />
											<img className="ml-1" src={sortQuery.titulo === "" ? Sort : sortQuery.titulo === "asc" ? SortAsc : SortDesc} alt="/" style={{ height: "12px", width: "22px" }} />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="politicasPrivacidad.version" defaultMessage="Versión" />
										</StyledTableCell>
										<StyledTableCell align="left">
											<FormattedMessage id="politicasPrivacidad.estado" defaultMessage="Estado" />
										</StyledTableCell>
										<StyledTableCell align="center" style={{ width: "150px" }}>
											<FormattedMessage id="movilesGrid.rennder.column_acciones.label" defaultMessage="Acciones" />
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{loading && (
										<TableRow>
											<StyledTableCell colSpan={6} align="center">
												<CircularProgress />
											</StyledTableCell>
										</TableRow>
									)}
									{!loading && (
										politicas.length > 0 ?
											politicas.map((politica) => (
												<PoliticasPrivacidadGridRow
													intl={intl}
													canVisualizar={canVisualizar}
													canCrear={canCrear}
													key={'politicasPrivacidadGridRow_' + politica.id}
													baseUrl={props.match.url}
													politica={politica}
												/>
											))
											:
											<TableRow>
												<StyledTableCell colSpan={6} align="center">
													<FormattedMessage id="movilesGrid.rennder.no_data_table" defaultMessage="No se encontraron resultados..." />
												</StyledTableCell>
											</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[5, 10, 25, 50, 100]}
							component="div"
							count={paginationCount}
							rowsPerPage={pagination.perPage}
							page={pagination.page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							labelRowsPerPage="Mostrar"
							labelDisplayedRows={({ from, to, count }) => "Mostrando " + from + " a " + to + " de " + count}
						/>
					</div>
				</div>
			</div>
		</>
	)
}

export default PoliticasPrivacidadGrid
